export default __webpack_public_path__ + "media/images/front/search/search_map-3a3ee14dd0d6689ea21e03ff670f34cd.png";